module.exports = __webpack_public_path__ + "img/temperature-sun.ccf12b05.svg";